import React, { Component } from 'react';
import './SectionTitle.css';

import blogIcon from '../icons/ic_blog.svg';
import josmIcon from '../icons/ic_josm.svg';
import toolsIcon from '../icons/ic_tools.svg';
import dataDumpsIcon from '../icons/ic_data_dumps.svg';
import aiIcon from '../icons/ic_ai.svg';

const iconMapping = {
  blog: blogIcon,
  josm: josmIcon,
  tools: toolsIcon,
  'data-dumps': dataDumpsIcon,
  ai: aiIcon,
};

const colorMapping = {
  blog: '#2BACE2',
  josm: '#2BACE2',
  tools: '#597EFF',
  'data-dumps': '#50B83C',
  ai: '#F66533',
};

class SectionTitle extends Component {
  render() {

    const {
      section,
      text,
    } = this.props;

    return (
      <div className="lp-section-title">
        <div style={{
          backgroundColor: colorMapping[section],
        }}>
          <img width="40" height="40" src={iconMapping[section]} alt={'Icon for ' + section}/>
        </div>
        <span>{text}</span>
      </div>
    );
  }
}

export default SectionTitle;



// WEBPACK FOOTER //
// ./src/components/SectionTitle.js